import { RxCross1 } from 'react-icons/rx';

const BookingNotAvailableDiv = () => {
  // rendering booking not available div component here
  return (
    <div className='flex items-center justify-center bg-base-red/30 py-3'>
      <RxCross1 className='size-5 text-base-red' />
    </div>
  );
};

export default BookingNotAvailableDiv;
